import { TextField, TextFieldProps, SxProps, Theme, Typography } from '@mui/material';
import { colors, fontSize, fontWeight } from '../../constants';

type BasicTextFieldProps = TextFieldProps & {
  labelText?: string;
  readOnly?: boolean;
};

const styles = {
  inputRoot: (readOnly: boolean): SxProps<Theme> => ({
    borderRadius: '8px',
    borderColor: colors.grayBorder,
    ...(readOnly && {
      pointerEvents: 'none',
      cursor: 'default',
      userSelect: 'text'
    })
  }),
  input: {
    fontSize: '16px',
    color: colors.black,
    '&::placeholder': {
      color: colors.grayLight,
      opacity: 1
    }
  },
  inputLabel: (): SxProps<Theme> => ({
    color: colors.blackOlive,
    fontSize: fontSize.small,
    fontWeight: fontWeight.medium
  })
};

const BasicTextField = ({
  labelText,
  readOnly = false,
  required,
  ...rest
}: BasicTextFieldProps) => {
  return (
    <>
      {labelText && (
        <Typography sx={styles.inputLabel()}>
          {labelText}
          {
            <Typography component="span" color="error">
              {required && ' *'}
            </Typography>
          }
        </Typography>
      )}
      <TextField
        aria-readonly={readOnly ? 'true' : 'false'}
        variant="outlined"
        required={required}
        InputProps={{
          inputProps: {
            readOnly: readOnly,
            style: {
              cursor: readOnly ? 'default' : undefined,
              userSelect: readOnly ? 'text' : undefined
            }
          },
          sx: {
            borderRadius: '8px',
            marginBottom: '10px',
            '& input': {
              fontSize: '16px',
              color: colors.black,
              padding: '8px 16px',
              '&::placeholder': {
                color: colors.grayBorder,
                opacity: 1
              }
            },
            '& fieldset': {
              borderColor: colors.grayBorder,
              borderWidth: '1.5px !important',
              display: 'flex',
              alignItems: 'center'
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: colors.grayBorder
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: colors.grayBorder
            },
            '& ~ .MuiFormHelperText-root': {
              margin: 0,
              marginTop: '1px !important'
            },
            ...(readOnly && {
              pointerEvents: 'none'
            })
          }
        }}
        {...rest}
      />
    </>
  );
};

export default BasicTextField;
